import React from "react";
import { useRecoilValue } from "recoil";
import ExamGuideFirst from "./ExamGuideFirst";
import ExamGuideSecond from "./ExamGuideSecond";
import ModeSelect from "./ModeSelect";
import Connect from "./Connect";
import { applyStepState } from "../../recoil/pageStep";
import ApplyLogin from "./ApplyLogin";
import PracLogin from "./PracLogin.jsx";
import Exam from "./Exam";
import ExamComplete from "./ExamComplete";
import VideoConfirm from "./VideoConfirm";
import ExamGuideThird from "./ExamGuideThird";
import ErrorPageGroupId from "./ErrorPageGroupId";
import PracGuide from "./PracGuide.jsx";
import ExamStartInfo from "./ExamStartInfo.jsx";
import Practice from "../../publish/Practice.jsx";


// 한수원xsli
export const ApplyStep = {
  MODE_SELECT: 0,
  APPLY_LOGIN: 1,
  PRACTICE_GUIDE: 2,
  PRACTICE_CONNECT: 3,
  PRACTICE_EXAM: 4,
  PRACTICE_DONE: 5,
  EXAM_START_INFO: 6,
  CONNECT: 7,
  EXAM: 8,
  RESULT: 9,
  ERROR_PAGE: -1,
}

export const userData = {
  type: "",
  name: "",
  sn: "",
};

export const logoURL = {
  uuid: "",
  logo: "https://opic.airsoundtest.com/media/group_logo/main_logo.svg",
  title: "",
};

const ApplyRouter = () => {
  const applyStep = useRecoilValue(applyStepState);

  // 한수원 x sli
  switch (applyStep) {
    case ApplyStep.MODE_SELECT:
      return <ModeSelect />
    case ApplyStep.APPLY_LOGIN:
      return <ApplyLogin />
    case ApplyStep.PRACTICE_GUIDE:
      return <ExamGuideFirst />
    case ApplyStep.PRACTICE_CONNECT:
      return <Connect />
    case ApplyStep.PRACTICE_EXAM:
      return <Exam />
    case ApplyStep.PRACTICE_DONE:
      return <VideoConfirm />
    case ApplyStep.EXAM_START_INFO:
      return <Practice />
    case ApplyStep.CONNECT:
      return <Connect />
    case ApplyStep.EXAM:
      return <Exam />
    case ApplyStep.RESULT:
      return <ExamComplete />
    case ApplyStep.ERROR_PAGE:
      return
    default:
  }
};

export default ApplyRouter;
